import { Drawer, DrawerProps } from 'antd';
import './style.scss';
import { CloseOutlined } from '@ant-design/icons';

type DrawerComponentProps = DrawerProps & {
  content: React.ReactNode;
  loading?: boolean;
};

const DrawerComponent = ({
  title,
  open,
  onClose,
  content,
  loading = false,
  closeIcon,
  ...props
}: DrawerComponentProps) => {
  return (
    <>
      <Drawer
        className="drawer-component"
        width={500}
        title={title}
        onClose={onClose}
        open={open}
        closable={!loading}
        maskClosable={!loading}
        closeIcon={closeIcon || <CloseOutlined />}
        {...props}
      >
        {content}
      </Drawer>
    </>
  );
};

export default DrawerComponent;
